// Array för produkter
window.produkter = [
  { title: "Labels on roll", url: "/collections/etiketter-1" },
  { title: "Circle stickers", url: "/products/runda-etiketter" },
  { title: "Square stickers", url: "/products/etiketter-med-runda-horn" },
  { title: "Square labels", url: "/products/kvadratiska-etiketter" }, 
  { title: "Oval labels", url: "/products/ovalarulletiketter" },
  { title: "Circle labels", url: "/products/rundarulletiketter" },
  { title: "Die-cut labels", url: "/products/die-cut-etiketter-pa-rulle" },
  { title: "Custom shape labels", url: "/products/die-cut-etiketter-pa-rulle" },
  { title: "Oval stickers", url: "/products/ovala-etiketter" },
  { title: "Rectangle labels", url: "/products/rektangulararulletiketter" },
  { title: "Rectangle stickers", url: "/products/rektangulara-etiketter" },
  { title: "Labels", url: "/collections/etiketter" },
  { title: "Holographic stickers", url: "/products/holografiska-stickers" },
  { title: "Glitter stickers", url: "/products/glitterstickers" },
  { title: "Clear stickers", url: "/products/transparenta-stickers" },
  { title: "Clear labels", url: "/products/transparenta-etiketter" },
  { title: "Stickers", url: "/collections/stickers" },
  { title: "Stickers", url: "/collections/stickers" },
  { title: "Sticker sheets", url: "/products/klistermarkesark" },
  { title: "Die-cut stickers", url: "/products/die-cut-etiketter-1" },
  { title: "Custom shape stickers", url: "/products/die-cut-etiketter-1" },
  { title: "Circle sheet labels", url: "/products/runda-arketiketter" },
  { title: "Square sheet labels", url: "/products/kvadratiska-arketiketter" },
  { title: "Rectangle sheet labels", url: "/products/rektangulara-arketiketter" },
  { title: "Round corner sheet labels", url: "/products/arketiketter-med-runda-horn" },
  { title: "Oval sheet labels", url: "/products/ovala-arketiketter" },
];

// Array för mallar
window.mallar = [
  { title: "Bottle labels", url: "/products/flasketiketter-1" },
  { title: "Beer labels", url: "/products/flasketiketter-1" },
  { title: "Wine labels", url: "/products/flasketiketter-1" },
  { title: "Can labels", url: "/products/burketiketter-1" },
  { title: "Circle labels", url: "/products/mallar-runda-etiketter" },
  { title: "Square labels", url: "/products/kvadratiska-etiketter-1" },
  { title: "Rectangle labels", url: "/products/rektangulara-etiketter-2" },
  { title: "Sheet labels", url: "/etiketter-pa-ark-1" },
  { title: "Oval labels", url: "/products/ovala-etiketter-1" },
  { title: "Die-cut stickers", url: "/products/konturskurna-klistermarken" },
  { title: "Custom shape stickers", url: "/products/konturskurna-klistermarken" },
  { title: "Custom shape labels", url: "/products/konturskurna-etiketter-1" },
  { title: "Circle stickers", url: "/products/runda-klistermarken" },
  { title: "Oval stickers", url: "/products/ovala-klistermarken" },
  { title: "Square stickers", url: "/products/kvadratiska-klistermarken" },
  { title: "Rectangle stickers", url: "/products/rektangulara-klistermarken" }
];